<script setup lang="ts">
import { SparklesIcon } from '@heroicons/vue/24/outline'

import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
import { translationFunctionDefault } from '@/utilities/translations'

defineProps<{
  show?: boolean
}>()

const tfDefault = translationFunctionDefault()
</script>

<template>
  <div
    v-if="show"
    class="mx-8 mb-8 rounded-xl bg-[linear-gradient(135deg,#cae8ff,#007ddd)] p-px"
    :data-testid="TEST_IDS_CREATE.createOrganizationForm.aiNoResultsBox"
  >
    <div class="flex flex-col gap-2 rounded-[11px] bg-lochmara-50 p-5">
      <div class="flex items-start gap-2 text-base font-medium leading-6 text-lochmara-600">
        <SparklesIcon aria-hidden="true" class="size-6 shrink-0 pt-px text-lochmara-500" />
        <span>{{ tfDefault('editRelationGroup.aiNoAdditionalResults') }}</span>
      </div>
    </div>
  </div>
</template>
